/* eslint-disable jsx-a11y/anchor-has-content */
import React from "react";
import Swiper from "swiper";

class Navigation extends React.Component {
  componentDidMount() {
    const { name } = this.props;
    const container = `.${name} .${name}-swiper-container`;
    const nextBtn = `.${name}-button-next`;
    const prevBtn = `.${name}-button-prev`;
    const pagination = `.${name}-swiper-pagination`;

    new Swiper(container, {
      slidesPerView: 3,
      spaceBetween: 0,
      slidesPerGroup: 3,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      },
      pagination: {
        el: pagination,
        clickable: true
      },
      breakpoints: {
        767: {
          slidesPerView: 2,
          slidesPerGroup: 1
        }
      }
    });
  }
  render() {
    const { recentlyViewed, name } = this.props;
    const width = document.body.offsetWidth;

    return (
      <div className={`swiper_wrap ${name}`}>
        <div className={`swiper-container ${name}-swiper-container`}>
          <div className="swiper-wrapper">{this.props.children}</div>
        </div>
        <div className="swiperArrows_wrap">
          {width < 768 ? null : (
            <>
              {/* 桌機版 */}
              {recentlyViewed.length > 3 ? (
                <>
                  <button className={`button-prev ${name}-button-prev`} />
                  <button className={`button-next ${name}-button-next`} />
                </>
              ) : (
                <>
                  <button className="swiper-button-hidden" />
                  <button className="swiper-button-hidden" />
                </>
              )}
            </>
          )}
        </div>
        {width < 768 && recentlyViewed.length > 1 ? (
          <div>
            <div
              className={`swiper-pagination ${name}-swiper-pagination`}
            ></div>
          </div>
        ) : null}
      </div>
    );
  }
}
export default Navigation;
